module.exports = __webpack_public_path__ + "static/media/fly0199.4cdbda45.webp";